import { render, staticRenderFns } from "./testPayment.vue?vue&type=template&id=7a36382d&scoped=true"
import script from "./testPayment.vue?vue&type=script&lang=js"
export * from "./testPayment.vue?vue&type=script&lang=js"
import style0 from "./testPayment.vue?vue&type=style&index=0&id=7a36382d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36382d",
  null
  
)

export default component.exports